import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCoupons, deleteCoupon } from '../../../../appRedux/actions';
import {
  TableMenuOpt,
  RenderStatus,
  ModalView,
  ListTable,
  TableFilters,
} from '../../../uiComponents';
import { useCustomModal } from '../../../../hooks/useCustomModal';
import { Button, Popover } from 'antd';
import {
  filters,
  searchFilters,
  searchInputInitialValues,
} from '../../../../constants/Coupon.const';
import { couponTypeDictionary, label } from '../../../../constants';
import { stringDate } from '../../../../util';
import { CouponModal } from '../CouponModal';
import { CouponPopoverProducts } from '../CouponPopoverProducts';

export const CouponTable = () => {
  const {
    privileges: { treatments: privileges = [] },
  } = useSelector((state) => state.userAuth);
  const dispatch = useDispatch();
  const [modalTitle, setModalTitle] = useState(null);
  const [modalData, setModalData] = useState({});
  const { catalogId, setModal } = useCustomModal();
  const { coupons } = useSelector((state) => state.coupon);

  const getModalData = useCallback(() => {
    const [modalData] = coupons?.filter((type) => type.id === catalogId);
    return modalData;
  }, [coupons, catalogId]);

  useEffect(() => {
    setModalTitle(getModalData()?.name);
    setModalData(getModalData());
  }, [getModalData]);

  const onDelete = (id) => {
    dispatch(deleteCoupon(id));
  };

  const hasItems = (record) => {
    return (
      record.product ||
      record.treatment ||
      (record.products && record.products.length > 0) ||
      (record.treatments && record.treatments.length > 0) ||
      (record.multiple && record.multiple.length > 0)
    );
  };

  const getTotalItemsCount = (record) => {
    if (record.product || record.treatment) return 1;
    return (
      (record.products?.length || 0) +
      (record.treatments?.length || 0) +
      (record.multiple?.length || 0)
    );
  };

  const getButtonText = (record) => {
    const count = getTotalItemsCount(record);
    if (record.product) return `Ver producto`;
    if (record.treatment) return `Ver tratamiento`;
    return `Ver ${count} producto${count !== 1 ? 's' : ''}`;
  };

  const renderCouponItems = (_, record) => {
    if (!hasItems(record)) return null;
    return (
      <Popover
        content={<CouponPopoverProducts coupon={record} />}
        trigger="click"
      >
        <Button type="link" size="small">
          {getButtonText(record)}
        </Button>
      </Popover>
    );
  };

  const columns = [
    {
      title: 'Código',
      sorter: true,
      dataIndex: 'code',
      key: 'code',
      render: (name, record) => (
        <Button
          type="link"
          htmlType="button"
          href="#/"
          onClick={() => setModal(record.id)}
        >
          {name}
        </Button>
      ),
    },
    {
      title: 'Límite',
      sorter: true,
      dataIndex: 'limit',
      key: 'limit',
    },
    {
      title: 'Usados',
      sorter: true,
      dataIndex: 'used',
      key: 'used',
    },
    {
      title: 'Nombre',
      sorter: true,
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Vigencia',
      sorter: true,
      dataIndex: 'expireDate',
      key: 'expireDate',
      render: (date) => stringDate(date),
      path: 'date',
      formatter: (date) => stringDate(date),
    },
    {
      title: 'Tipo',
      dataIndex: 'type',
      key: 'type',
      render: (type) => couponTypeDictionary[type],
      path: 'type',
      formatter: (type) => couponTypeDictionary[type],
    },
    {
      title: 'Producto',
      dataIndex: 'type',
      key: 'type',
      render: renderCouponItems,
    },
    {
      title: 'Estado',
      sorter: true,
      dataIndex: 'status',
      key: 'status',
      render: (status) => <RenderStatus data={{ status }} />,
      path: 'status',
      formatter: (value) => (value ? label.activeText : label.inactiveText),
    },
    {
      title: 'Opciones',
      key: 'id',
      render: (_, { id }) => (
        <TableMenuOpt
          id={id}
          privileges={privileges}
          path={'cupones'}
          action={{
            onDelete: {
              action: onDelete,
              params: [id],
            },
          }}
        />
      ),
    },
  ];

  return (
    <>
      <TableFilters
        privileges={privileges}
        searchFilters={searchFilters}
        filters={filters}
        searchInputInitialValues={searchInputInitialValues}
      />
      <ListTable
        columns={columns}
        getDataFunction={getCoupons}
        privileges={privileges}
      />
      <ModalView title={modalTitle} width={850}>
        <CouponModal data={modalData} />
      </ModalView>
    </>
  );
};
